export default "__VITE_ASSET__CpqqaOfN__"